import React from 'react';
import cx from 'classnames';
import { string, object } from 'prop-types';

const CLASS_ROOT = 'separator';

const propTypes = {
  src: string,
  style: object,
};

const Separator = ({ className, style, src, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return (
    <svg className={classes} {...style} {...other}>
      <use xlinkHref={`#${src}`} />
    </svg>
  );
};

Separator.propTypes = propTypes;

export default Separator;
